module.exports = __webpack_public_path__ + "img/icon-ai-light-blue.35b3d18f.svg";